
import sha1 from 'sha1'
import { ElMessage, FormInstance, FormRules } from 'element-plus'
import { defineComponent, reactive, toRefs, ref, onMounted, computed } from 'vue'
import { useStore } from 'vuex'
import { useRouter, useRoute } from 'vue-router'
import { getcode, register } from '@/collaborateapi/login'
export default defineComponent({
	setup() {
		const carouseData = [
			{ url: require('@/assets/collaborateimg/1.png') },
			{ url: require('@/assets/collaborateimg/2.png') },
			{ url: require('@/assets/collaborateimg/3.png') },
			{ url: require('@/assets/collaborateimg/4.png') },
			{ url: require('@/assets/collaborateimg/5.png') },
			{ url: require('@/assets/collaborateimg/6.png') }
		]
		const logo = require('../../assets/logo.png')
		const activeName = ref('first')
		// useRouter相当于this.$router
		const router = useRouter()
		// useRoute相当于以前的this.$route
		const route = useRoute()
		const store = useStore()
		// 定义是否是登录状态
		const isLoading = ref(false)
		// 表单实例-->调用内置的校验规则
		const formRef = ref<FormInstance>()
		const formRef1 = ref<FormInstance>()
		const radio2 = ref('1')
		// FormRules是element自带表单校验的规则
		const state = reactive<{
			form: any
			rules: FormRules
			rules1: FormRules
			registerform: any
			countDownTime: any
			timer: any
			countDownIng: any
			getCodeDisabled: any
			formLabelWidth: any
		}>({
			form: {
				// 13144443001
				phone: '',
				// 123456789
				password: '',
				nonce1: '123456',
				nonce2: '123456',
				nonce3: 'iCampusManagePlatformNonce3',
				encrypt: ''
			},
			// 定义表单定义规则
			rules: {
				// blur失去光标
				phone: [
					{ required: true, message: '电话号码不能为空', trigger: 'blur' },
					// { pattern: /^1\d{10}$/, message: '电话号码必须是11位数字', trigger: 'blur' }
					{ pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/, message: '手机号格式错误', trigger: 'blur' }
				],
				password: [
					{ required: true, message: '请输入密码', trigger: 'blur' },
					{ min: 6, max: 18, message: '密码长度需要6~18位', trigger: 'blur' }
				]
			},
			rules1: {
				// blur失去光标
				phone: [
					{ required: true, message: '电话号码不能为空', trigger: 'blur' },
					{ pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/, message: '手机号格式错误', trigger: 'blur' }
				],
				code: [{ required: true, message: '验证码不能为空', trigger: 'blur' }],
				password: [
					{ required: true, message: '请输入密码', trigger: 'blur' },
					{ min: 6, max: 18, message: '密码长度需要6~18位', trigger: 'blur' }
				],
				allpassword: [{ required: true, message: '请再次输入密码', trigger: 'blur' }],
				ty: [{ required: true, message: '请选择用户类型', trigger: 'blur' }]
			},
			// 注册的数据
			registerform: {
				phone: '',
				code: '',
				password: '',
				allpassword: '',
				ty: '1'
			},
			// 倒计时
			countDownTime: 60,
			timer: null,
			countDownIng: false,
			getCodeDisabled: false,
			formLabelWidth: '110px'
		})

		const submit = async () => {
			isLoading.value = true
			// 表单验证
			await formRef.value?.validate().catch((err) => {
				ElMessage.error('登录信息有误')
				isLoading.value = false
				// 阻拦往下执行
				throw err
			})
			// 1.新建一个数组,存放被拆分和组合的暑假
			let arr: any[] = []
			// 2.将nonce1和nonce2进行拆分组合
			for (var i = 0; i < 6; i++) {
				arr[i] = state.form.nonce1.split('')[i] + state.form.nonce2.split('')[i]
			}
			// 3.进行拼接
			let afterencrypt: string = arr.join('') + state.form.nonce3
			// 4.实现两次sha1操作
			let totalencrypt2 = sha1(afterencrypt)
			let totalencrypt22 = sha1(totalencrypt2)

			setTimeout(() => {
				isLoading.value = false
				store
					.dispatch('user/login12', {
						phone: state.form.phone,
						password: state.form.password
						// nonce1: state.form.nonce1,
						// nonce2: state.form.nonce2,
						// encrypt: totalencrypt22
					})
					.then((res) => {
						isLoading.value = true
						ElMessage({
							message: '登录成功',
							type: 'success'
						})
						setTimeout(() => {
							// 跳转首页路由
							router.push('/')
							isLoading.value = false
						}, 100)
					})
					.catch((err) => {
						// 如果输入账号密码错误,就理解解绑按钮的loading效果
						isLoading.value = false
						ElMessage.error('登录失败')
					})
			}, 1000)
		}
		const countDown = async () => {
			const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
			if (state.registerform.phone == '') {
				return ElMessage.error('手机号不能为空')
			}
			if (state.registerform.phone.length <= 10) {
				return ElMessage.error('手机号长度应为11位')
			}
			if (!reg.test(state.registerform.phone)) {
				return ElMessage.error('手机号格式错误')
			}

			// let startTime: any = localStorage.getItem('startTimeLogin')
			// let nowTime: any = new Date().getTime()
			// if (startTime) {
			// 	let jian: string = ((nowTime - startTime) / 1000).toString()
			// 	let surplus = 60 - parseInt(jian, 10)
			// 	state.countDownTime = surplus <= 0 ? 0 : surplus
			// } else {
			// 	state.countDownTime = 60
			// 	localStorage.setItem('startTimeLogin', nowTime)
			// }
			state.timer = setInterval(() => {
				state.countDownTime--
				state.getCodeDisabled = true
				state.countDownIng = true
				if (state.countDownTime <= 0) {
					// localStorage.removeItem('startTimeLogin')
					clearInterval(state.timer)
					state.countDownTime = 60
					state.countDownIng = false
				}
			}, 1000)
			let result: any = await getcode({ phone: state.registerform.phone })
			if (result.code == 0) {
				console.log(result)
				ElMessage({
					message: '验证码正在发送',
					type: 'success'
				})
			} else {
				ElMessage({
					message: result.data,
					type: 'error'
				})
			}
		}

		// onMounted(() => {
		// 	let sendEndTi me = localStorage.getItem('startTimeLogin')
		// 	if (sendEndTime) {
		// 		state.countDownIng = true
		// 		countDown()
		// 	}
		// })

		// 点击注册按钮
		const registerbtn = async () => {
			await formRef1.value?.validate().catch((err) => {
				ElMessage.error('注册信息有误')
				// 阻拦往下执行
				throw err
			})
			if (state.registerform.password != state.registerform.allpassword) {
				return ElMessage.error('两次输入密码不一致')
			}
			let result: any = await register({
				phone: state.registerform.phone,
				password: state.registerform.password,
				code: parseInt(state.registerform.code),
				ty: parseInt(state.registerform.ty)
			})
			if (result.code == 0) {
				console.log(result)
				ElMessage({
					message: '注册成功',
					type: 'success'
				})
				// 跳转到登录页面--->进行一个账号密码的自动填入
				activeName.value = 'first'
				state.form.phone = state.registerform.phone
				state.form.password = state.registerform.password
			} else {
				ElMessage({
					message: result.message,
					type: 'error'
				})
			}
			console.log(result)
		}
		return {
			...toRefs(state),
			submit,
			formRef,
			isLoading,
			activeName,
			logo,
			carouseData,
			countDown,
			formRef1,
			registerbtn,
			radio2
		}
	}
})
